/** Прежний бинарный ключ согласия — оставлен для миграции решения */
export const cookieConfirmKey = 'cookieConfirmKey'

/** Решение по категориям cookies (ТЗ аналитики §11.2), формат StoredConsent */
export const consentStorageKey = 'skuby_consent'

/** Снимок источника трафика первого касания (ТЗ §6.2), формат StoredAttribution */
export const attributionStorageKey = 'skuby_attribution'

export enum CookieStatus {
  accept = 'accept',
  decline = 'decline',
}
